// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__2w4K-"};